/**
 * The account's own lines, read once and shared.
 *
 * Two pages paint them — /lines and the study's picker — and the legacy form creates them, so the
 * list cannot live inside either of them. Null means nobody has asked the server yet, which is not
 * the same as an account with no lines.
 */
export const linesSlice = {
    own: null,
    /** How far back the ranking of their games looks, in days. Null until a page has read it. */
    window: null,
};
